import { 
    LOG_OUT_USER,
    FETCH_MESSAGES,
 } from '../../actions/actionTypes';

const fetchMessagesReducer = (messagesOrder, payload) => {
    let newMessagesOrder = payload.appendData ? [ ...messagesOrder ] : [];
    if (payload.messages)
    {
        for(let m of payload.messages){
            newMessagesOrder.push(m.messageId);
        }
    }
   
    let uniqueIds = [...new Set(newMessagesOrder)];
    return uniqueIds;
}

const messagesOrderReducer = (state=[], action) => {
    let messagesOrder = state;
    if(action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_MESSAGES:
                return fetchMessagesReducer(messagesOrder, action.payload);  
            case LOG_OUT_USER:
                return [];
            default:
                return messagesOrder;
        }
    }
    return messagesOrder;
}

export default messagesOrderReducer;